import React from 'react';
import { SWOTAnalysis } from '../types';
import { decryptString } from '../lib/security';

interface AnalysisCardProps {
  analysis: SWOTAnalysis;
}

export const AnalysisCard: React.FC<AnalysisCardProps> = ({ analysis }) => {
  // فك تشفير البيانات قبل عرضها
  const decryptArray = (arr: string[]) => arr.map(decryptString);

  return (
    <div className="border-b border-gray-200 pb-8 last:border-b-0">
      <h3 className="text-xl font-bold text-gray-800 mb-4 break-words">
        {analysis.project_name}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-green-50 p-6 rounded-xl border border-green-100">
          <h4 className="font-bold text-green-800 mb-3 text-lg">نقاط القوة</h4>
          <ul className="space-y-2 list-disc list-inside text-gray-700">
            {decryptArray(analysis.strengths).map((strength, i) => (
              <li key={i} className="break-words">{strength}</li>
            ))}
          </ul>
        </div>
        <div className="bg-red-50 p-6 rounded-xl border border-red-100">
          <h4 className="font-bold text-red-800 mb-3 text-lg">نقاط الضعف</h4>
          <ul className="space-y-2 list-disc list-inside text-gray-700">
            {decryptArray(analysis.weaknesses).map((weakness, i) => (
              <li key={i} className="break-words">{weakness}</li>
            ))}
          </ul>
        </div>
        <div className="bg-blue-50 p-6 rounded-xl border border-blue-100">
          <h4 className="font-bold text-blue-800 mb-3 text-lg">الفرص</h4>
          <ul className="space-y-2 list-disc list-inside text-gray-700">
            {decryptArray(analysis.opportunities).map((opportunity, i) => (
              <li key={i} className="break-words">{opportunity}</li>
            ))}
          </ul>
        </div>
        <div className="bg-yellow-50 p-6 rounded-xl border border-yellow-100">
          <h4 className="font-bold text-yellow-800 mb-3 text-lg">التهديدات</h4>
          <ul className="space-y-2 list-disc list-inside text-gray-700">
            {decryptArray(analysis.threats).map((threat, i) => (
              <li key={i} className="break-words">{threat}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};